// extracted by mini-css-extract-plugin
export default {"tablecontainer":"UserManagementListTable_tablecontainer__jYe5h","tablemain":"UserManagementListTable_tablemain__ZjvHq"};